import React from 'react';

interface GazeDotProps {
  x: number;
  y: number;
  active: boolean;
}

export function GazeDot({ x, y, active }: GazeDotProps) {
  return (
    <div
      className={`gaze-dot ${active ? 'active' : ''}`}
      style={{ left: x, top: y }}
    />
  );
}
